/**
 * roomGuards.js — controlli lato client per le Room.
 *
 * NIENTE LINK nelle stanze: una stanza è conversazione, non un canale di
 * distribuzione. I link sono il "ponte" verso media illegali ospitati altrove.
 *
 * ⚠️ È best-effort lato client (E2E: il server non legge il testo). Un client
 * modificato lo aggira, e due umani che vogliono scambiarsi un URL ci riescono
 * comunque. Vale come INTENTO DI DESIGN ("le stanze non sono per i link"), non
 * come garanzia assoluta. Calibrato per beccare i casi reali senza falsi
 * positivi sul parlato normale.
 */

// Caratteri invisibili usati per spezzare i pattern.
const ZERO_WIDTH = /[​-‍⁠﻿]/g;

// Omoglifi cirillici/greci più comuni → latino (per "ехаmрlе.com" ecc.).
const HOMOGLYPHS = {
  а: 'a', е: 'e', о: 'o', р: 'p', с: 'c', х: 'x', у: 'y', к: 'k', м: 'm',
  н: 'h', т: 't', в: 'b', і: 'i', ѕ: 's', ո: 'n', օ: 'o', ɑ: 'a',
  ο: 'o', ρ: 'p', τ: 't', ν: 'v', κ: 'k', μ: 'm', ι: 'i',
};

// TLD comuni: bilancia copertura e falsi positivi (no TLD esotici che
// coincidono con parole, es. evitiamo di trattare "a.s" come dominio).
const TLD = 'com|net|org|io|it|co|me|app|dev|info|biz|eu|uk|de|fr|es|ch|gg|tv|xyz|live|link|to|gl|ly|be|cc|site|online|store|shop|ru|cn|us';

function normalize(s) {
  let t = String(s || '').toLowerCase();
  t = t.replace(ZERO_WIDTH, '');
  t = t.replace(/[Ѐ-ӿͰ-Ͽɐ-ʯ]/g, (c) => HOMOGLYPHS[c] || c);
  // Offuscazione del punto: "[.]", "(.)", "{.}", " dot ", " punto " (tra token
  // che sembrano parti di dominio) → "."
  t = t.replace(/\s*[\[\(\{]\s*\.\s*[\]\)\}]\s*/g, '.');           // [.] (.) {.}
  t = t.replace(/\b(dot)\b/g, '.');                                // "esempio dot com"
  t = t.replace(/([a-z0-9-]{2,})\s+punto\s+([a-z]{2,})/g, '$1.$2'); // "esempio punto com"
  // "hxxp", "h x x p", "h t t p" → "http"
  t = t.replace(/h\s*[x]\s*[x]\s*p/g, 'http');
  t = t.replace(/h\s*t\s*t\s*p/g, 'http');
  // Spazi attorno al punto in un dominio: "esempio . com" → "esempio.com"
  t = t.replace(/([a-z0-9-]{2,})\s*\.\s*([a-z]{2,})/g, '$1.$2');
  return t;
}

const URL_RE = /(?:https?:\/\/|www\.)\S{2,}/i;
// Il `[^a-z0-9@.]` davanti esclude i domini dentro le email (legittime in una
// stanza pratica): "mario@studio.it" NON viene flaggato.
const DOMAIN_RE = new RegExp(`(?:^|[^a-z0-9@.])([a-z0-9][a-z0-9-]{1,}\\.(?:${TLD}))(?![a-z0-9])`, 'i');

/**
 * true se il testo (normalizzato dagli offuscamenti comuni) contiene un URL o
 * un dominio. Le email sono consentite.
 */
export function containsLink(text) {
  const t = normalize(text);
  return URL_RE.test(t) || DOMAIN_RE.test(t);
}
